import { render, staticRenderFns } from "./CompanyLayout.vue?vue&type=template&id=42fa8e75"
import script from "./CompanyLayout.vue?vue&type=script&lang=js"
export * from "./CompanyLayout.vue?vue&type=script&lang=js"
import style0 from "./CompanyLayout.vue?vue&type=style&index=0&id=42fa8e75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports